import { createContext, useContext } from "react";
import { BehaviorSubject, Subject } from "rxjs";
import { CadUploadConfigUnit } from "@iventis/domain-model/model/cadUploadConfigUnit";
import { GeoReferencerCadMode } from "../types/georeferencer-cad-mode";
import { CadControlPoint } from "../mapbox/types";
import { MapBackground } from "../types/map-background";

export interface SubjectContext {
    cadRotation$: BehaviorSubject<number>;
    mapZoom$: Subject<{ source: "toolbar" | "cad-map" | "background-map"; value: number }>;
    // Allowing movement of maps
    allowCadMovePosition$: Subject<boolean>;
    allowBackgroundMapMovePosition$: Subject<boolean>;
    searchLocationSelected$: Subject<[number, number, number, number]>;
    backgroundSelected$: Subject<MapBackground>;
    unitsSelected$: BehaviorSubject<CadUploadConfigUnit>;
    unitsError$: BehaviorSubject<string>;
    mode$: BehaviorSubject<GeoReferencerCadMode>;
    controlPoints$: BehaviorSubject<CadControlPoint[] | null>;
    // Filtered layers
    filterLayers$: BehaviorSubject<string[]>;
}

export const initialSubjectContext: SubjectContext = {
    mapZoom$: new Subject<{ source: "toolbar" | "cad-map" | "background-map"; value: number }>(),
    cadRotation$: new BehaviorSubject<number>(0),
    allowCadMovePosition$: new Subject<boolean>(),
    allowBackgroundMapMovePosition$: new Subject<boolean>(),
    searchLocationSelected$: new Subject<[number, number, number, number]>(),
    backgroundSelected$: new Subject<MapBackground>(),
    unitsSelected$: new BehaviorSubject<CadUploadConfigUnit>(CadUploadConfigUnit.Metres),
    unitsError$: new BehaviorSubject<string>(null),
    mode$: new BehaviorSubject<GeoReferencerCadMode>(GeoReferencerCadMode.WaitingForFile),
    filterLayers$: new BehaviorSubject<string[]>([]),
    controlPoints$: new BehaviorSubject<CadControlPoint[] | null>(null),
};

export const SubjectsContext = createContext<SubjectContext>(initialSubjectContext);

export function useSubjectContext() {
    return useContext(SubjectsContext);
}
